import React from "react";
import { Link, useLocation } from "react-router-dom";

// ============================================================================
// Footer — global footer with legal/commercial links.
// Rendered inside Layout. Visible on every page (except the Splash route
// which is rendered outside Layout).
// ============================================================================
const LINKS = [
  { to: "/pricing", label: "Pricing", testid: "footer-link-pricing" },
  { to: "/terms-of-service", label: "Terms of Service", testid: "footer-link-terms" },
  { to: "/privacy-policy", label: "Privacy Policy", testid: "footer-link-privacy" },
  { to: "/refund-policy", label: "Refund Policy", testid: "footer-link-refund" },
  { to: "/disclaimer", label: "Disclaimer", testid: "footer-link-disclaimer" },
  { to: "/contact", label: "Contact", testid: "footer-link-contact" },
  { to: "/reference", label: "Reference", testid: "footer-link-reference" },
];

export default function Footer() {
  const loc = useLocation();
  return (
    <footer
      data-testid="app-footer"
      className="border-t mt-6 pt-4 pb-4"
      style={{ borderColor: "var(--rs-border)" }}
    >
      <nav
        aria-label="Legal and commercial"
        className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2"
      >
        {LINKS.map(({ to, label, testid }) => {
          const isActive = loc.pathname === to;
          return (
            <Link
              key={to}
              to={to}
              data-testid={testid}
              className="text-[11px] tracking-[0.10em] uppercase font-semibold transition-colors"
              style={{
                color: isActive ? "var(--rs-amber)" : "var(--rs-text-3)",
              }}
            >
              {label}
            </Link>
          );
        })}
      </nav>
      <div
        className="text-center text-[10px] text-[var(--rs-text-3)] mt-3"
        data-testid="footer-copyright"
      >
        © {new Date().getFullYear()} RigSentinel. All rights reserved.
      </div>
      <div
        className="text-center text-[10px] text-[var(--rs-text-3)] mt-1 px-4 leading-relaxed"
        data-testid="footer-disclaimer-note"
      >
        RigSentinel provides deterministic calculation support and reference
        templates only. Outputs must be independently verified by qualified
        personnel before any operational use.
      </div>
    </footer>
  );
}
